import axios from 'axios';

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/web/api',
  timeout: 15000,
  headers: {
    'X-CDGC-Web': '1',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

client.interceptors.response.use(
  (resp) => {
    const data = resp && resp.data ? resp.data : null;
    if (!data || typeof data !== 'object') return resp;
    // 兼容 web 路由 { error_code, data } 和 app 路由 { code, data }
    const code = data.error_code ?? data.code;
    if (code !== undefined && code !== 0) {
      const err = new Error(data.message || '请求失败');
      err.code = code;
      err.data = data.data;
      throw err;
    }
    return data.data;
  },
  (error) => {
    throw error;
  }
);

export default client;
